// Chakra imports
import {
  Box,
  Button,
  Flex,
  Icon,
  Portal,
  Spacer,
  Text,
  useColorModeValue,
  Skeleton,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import IconBox from "components/Icons/IconBox";
import React, { useState, useEffect } from "react";
import { SWDLogo, ClockIcon } from "components/Icons/Icons";
// react icons
import { BsArrowRight } from "react-icons/bs";
import axios from "axios";
import apiUrl from "variables/api";
import { toast } from "react-toastify";

import { useMediaQuery } from "react-responsive";
const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 992 });
  return isDesktop ? children : null;
};

const WorkWithTheRockets = ({ title, description, backgroundImage }) => {
  const textColor = useColorModeValue("gray.700", "white");
  const secondTextColor = useColorModeValue("gray.500", "gray.100");
  const iconRed = useColorModeValue("red.500", "red.500");
  const navbarIcon = useColorModeValue("gray.500", "gray.200");
  const overlayRef = React.useRef();

  const calculateTimeAgo = (addTime) => {
    const now = new Date();
    const articleDate = new Date(addTime);
    const diff = now - articleDate;

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    if (days > 0) {
      return `${days} ${days === 1 ? "dzień" : days < 5 ? "dni" : "dni"}`;
    } else if (hours > 0) {
      return `${hours} ${
        hours === 1 ? "godzina" : hours < 5 ? "godziny" : "godzin"
      }`;
    } else if (minutes > 0) {
      return `${minutes} ${
        minutes === 1 ? "minuta" : minutes < 5 ? "minuty" : "minut"
      } temu`;
    } else {
      return "przed chwilą";
    }
  };

  const [article, setArticle] = useState("");
  useEffect(() => {
    axios
      .get(apiUrl + "/data/article", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        setArticle(response.data);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
  }, []);

  return (
    <Card maxHeight="290.5px" p="1rem">
      <CardBody
        p="0px"
        bgPosition="center"
        bgRepeat="no-repeat"
        w="100%"
        h={{ sm: "200px", lg: "100%" }}
        bgSize="cover"
        position="relative"
        borderRadius="15px"
      >
        <Skeleton height={"100%"} isLoaded={article}>
          <Flex
            flexDirection={"row"}
            h={"100%"}
            justifyContent={"space-between"}
          >
            <Flex
              flexDirection="column"
              color={textColor}
              p={"10px"}
              lineHeight={1.6}
            >
              <Flex alignItems="center" mb={"5px"}>
                  <ClockIcon color={navbarIcon} w="13px" h="13px" me="3px" />
                  <Text fontSize="xs" lineHeight="100%" color={navbarIcon}>
                    {calculateTimeAgo(article.addTime)}
                  </Text>
              </Flex>
              <Text fontSize="xl" fontWeight="bold" pb=".3rem">
                Najnowszy artykuł zespołu prasowego
              </Text>
                <Text
                  fontSize="sm"
                  fontWeight="normal"
                  w={{ lg: "70%" }}
                  style={{ overflowY: "auto" }}
                  color={secondTextColor}
                >
                  {article.title}
                </Text>
              <Spacer />
              <Flex align="center">
                <Button
                  as="a"
                  p="0px"
                  variant="no-hover"
                  bg="transparent"
                  mt="12px"
                  href={article.link}
                  target="_blank"
                >
                  <Text
                    fontSize="sm"
                    fontWeight="bold"
                    _hover={{ me: "4px" }}
                    transition="all .5s ease"
                  >
                    Przeczytaj na forum
                  </Text>
                  <Icon
                    as={BsArrowRight}
                    w="20px"
                    h="20px"
                    fontSize="xl"
                    transition="all .5s ease"
                    mx=".3rem"
                    cursor="pointer"
                    _hover={{ transform: "translateX(20%)" }}
                    pt="4px"
                  />
                </Button>
              </Flex>
            </Flex>
            <Desktop>
              <IconBox as="div" h={"100%"} w={"200px"} bg={iconRed}>
                <SWDLogo w="100px" h="100px" />
              </IconBox>
            </Desktop>
          </Flex>
        </Skeleton>
      </CardBody>
    </Card>
  );
};

export default WorkWithTheRockets;
